export default __webpack_public_path__ + "static/hero-animation-04-40c3b8a230da20f084ec0d67de57a822.svg";